const devBaseURL = "/manage-rest/";
const proBaseURL = "/manage-rest/";
export const BASE_URL =
  process.env.NODE_ENV === "development" ? devBaseURL : proBaseURL;

export const TIMEOUT = 600000;
